<div [ngClass]="containerClass()" [class]="styleClass" [ngStyle]="style" role="separator">
</div>
